import React from "react";
import HPSelectModal from "../common/HPSelectModal";
import { t } from "@utils/i18n";
import { useAppDispatch } from "@/store";
import { modalDispatcher } from "@/store/slices/modal-slice";

interface DatasetOption {
  id: string;
  name: string;
}

interface SelectDatasetForSurveysModalProps {
  datasets: DatasetOption[];
  onSelect: (datasetId: string) => void;
}

const SelectDatasetForSurveysModal: React.FC<
  SelectDatasetForSurveysModalProps
> = ({ datasets, onSelect }) => {
  const dispatch = useAppDispatch();
  const { closeTopModal } = modalDispatcher(dispatch);

  return (
    <HPSelectModal
      onClose={closeTopModal}
      title={t("modals.selectDatasetForSurveys.title")}
      items={datasets}
      onAdd={onSelect}
      addButtonText={t("modals.selectDatasetForSurveys.confirmButton")}
    />
  );
};

export default SelectDatasetForSurveysModal;
